import { DialogActions } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../redux/types'
import { CancelButton, SaveButton } from '../inputs'

interface CustomDialogActionsProps {
  handleSubmit: any
  handleClose: any
}

export function CustomDialogActions({ handleSubmit, handleClose }: CustomDialogActionsProps) {
  const { t } = useTranslation(['global'])
  const { isValidForm, msgForm } = useSelector((state: IRootState) => state.validator)

  return (
    <DialogActions
      sx={[
        !isValidForm &&
          Object.keys(msgForm).length > 0 && {
            backgroundColor: theme => theme.palette.warning.light
          }
      ]}
    >
      <CancelButton onClick={handleClose} aria-label="close">
        {t('cancel')}
      </CancelButton>
      <SaveButton autoFocus id="btn-save-user" onClick={() => handleSubmit()}>
        {t('save')}
      </SaveButton>
    </DialogActions>
  )
}
